import { updateVariationsErrors } from '../../validations/variations';
import { shapeVariationsForApp } from '../../variations/shapeForApp';
import { isProfileOperation } from '../../variations/operations';
import { replaceOperation } from '../../product/operations';
import { editVariations } from '../variations';
import { retain } from '../../variations/retain';
import { get } from '../../iterable/get';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../../constants/channels';
import { ATTRIBUTE } from '../../../constants/attributes';
import { VALUE } from '../../../constants/product';
import { EMPTY } from '../../../constants';
import { FORM } from '../../../constants/forms';

export function variations({ operation, product, shopData, taxonomyData, ...rest }) {
  const channel = product.get('channel');

  switch (channel) {
    case EBAY: {
      const category = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_CATEGORY, VALUE]);

      if (get(['CATEGORIES', category, 'features', 'variations'])(taxonomyData) === false) {
        return { product, ...rest };
      }

      const itemSpecifics = product.getIn([FORM.DETAILS, ATTRIBUTE.ITEM_SPECIFICS], EMPTY.MAP);
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shopData,
        taxonomyData,
        value: updateVariationsErrors({ category, channel, itemSpecifics, shopData, taxonomyData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case ETSY: {
      if (product.getIn([FORM.DETAILS, ATTRIBUTE.DIGITAL, VALUE])) {
        return { product, ...rest };
      }

      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shopData,
        value: updateVariationsErrors({ channel, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case FAIRE: {
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shopData,
        value: updateVariationsErrors({ channel, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    case SHOPIFY: {
      const asProfile = isProfileOperation({ channel, operation });
      let result = shapeVariationsForApp({ asProfile, data: operation.get(VALUE), product });

      if (asProfile) {
        result = retain({ channel, product, shopData, variations: result, validate: false });
      }

      const updates = editVariations({
        product,
        shopData,
        value: updateVariationsErrors({ channel, shopData, variations: result }),
      });

      return {
        ...rest,
        product: updates.product = updates.product.set('operations',
          updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
        ),
      };
    }

    default: {
      return { product, ...rest };
    }
  }
}
